import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { ArrowLeft, Construction } from "lucide-react";

export default function PhasePlaceholder({ title, phase, children }) {
    const nav = useNavigate();
    return (
        <div className="min-h-screen flex items-center justify-center px-6">
            <div className="km-card p-10 max-w-lg w-full text-center space-y-5">
                <div className="w-14 h-14 rounded-full bg-[color:var(--km-amber)]/15 mx-auto flex items-center justify-center">
                    <Construction size={26} className="text-[color:var(--km-amber)]" strokeWidth={1.5} />
                </div>
                <h1 className="font-extrabold tracking-[-0.03em] text-3xl">{title}</h1>
                <div className="text-sm text-muted">
                    Ships in <strong className="text-ink">{phase}</strong>.
                    {children}
                </div>
                <Button variant="outline" onClick={() => nav("/admin")} className="gap-2">
                    <ArrowLeft size={16} /> Back to dashboard
                </Button>
            </div>
        </div>
    );
}
